<template>
   <div id="keyboard">
      <div class="selected-clue-header">
         <div class="clue-text">
            <span style="font-weight: bold;">
               {{ clue?.number }} {{ xSelect ? "ACROSS" : "DOWN" }}.
            </span>
            <span>
               {{ clue?.clue }}
            </span>
         </div>
         <i class="bi bi-chevron-compact-right right-chevron" @click="emitCrosswordKeyEvent('NEXTCLUE')"></i>
      </div>
      <ul>
         <div class="keyline">
            <li @click="emitCrosswordKeyEvent('Q')"><span class="on">Q</span></li>
            <li @click="emitCrosswordKeyEvent('W')"><span class="on">W</span></li>
            <li @click="emitCrosswordKeyEvent('E')"><span class="on">E</span></li>
            <li @click="emitCrosswordKeyEvent('R')"><span class="on">R</span></li>
            <li @click="emitCrosswordKeyEvent('T')"><span class="on">T</span></li>
            <li @click="emitCrosswordKeyEvent('Y')"><span class="on">Y</span></li>
            <li @click="emitCrosswordKeyEvent('U')"><span class="on">U</span></li>
            <li @click="emitCrosswordKeyEvent('I')"><span class="on">I</span></li>
            <li @click="emitCrosswordKeyEvent('O')"><span class="on">O</span></li>
            <li @click="emitCrosswordKeyEvent('P')"><span class="on">P</span></li>
         </div>
         <div class="keyline">
            <li @click="emitCrosswordKeyEvent('A')"><span class="on">A</span></li>
            <li @click="emitCrosswordKeyEvent('S')"><span class="on">S</span></li>
            <li @click="emitCrosswordKeyEvent('D')"><span class="on">D</span></li>
            <li @click="emitCrosswordKeyEvent('F')"><span class="on">F</span></li>
            <li @click="emitCrosswordKeyEvent('G')"><span class="on">G</span></li>
            <li @click="emitCrosswordKeyEvent('H')"><span class="on">H</span></li>
            <li @click="emitCrosswordKeyEvent('J')"><span class="on">J</span></li>
            <li @click="emitCrosswordKeyEvent('K')"><span class="on">K</span></li>
            <li @click="emitCrosswordKeyEvent('L')"><span class="on">L</span></li>
         </div>
         <div class="keyline">
            <li class="special-key" @click="emitCrosswordKeyEvent('CLOSE')">
               <span class="on"><i class="bi bi-arrow-down-square"></i></span>
            </li>
            <li @click="emitCrosswordKeyEvent('Z')"><span class="on">Z</span></li>
            <li @click="emitCrosswordKeyEvent('X')"><span class="on">X</span></li>
            <li @click="emitCrosswordKeyEvent('C')"><span class="on">C</span></li>
            <li @click="emitCrosswordKeyEvent('V')"><span class="on">V</span></li>
            <li @click="emitCrosswordKeyEvent('B')"><span class="on">B</span></li>
            <li @click="emitCrosswordKeyEvent('N')"><span class="on">N</span></li>
            <li @click="emitCrosswordKeyEvent('M')"><span class="on">M</span></li>
            <li class="special-key" @click="emitCrosswordKeyEvent('BACKSPACE')">
               <span class="on"><i class="bi bi-backspace"></i></span>
            </li>
         </div>
      </ul>
   </div>
</template>


<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { PropType } from 'vue';
import { Clue } from '@/models/Crossword';
import { emitCrosswordKeyEvent } from '@/service/crosswords';

@Options({
  props: {
    clue: {
      required: true,
      type: Object as PropType<Clue | null>,
    },
    xSelect: {
      required: true,
      type: Boolean,
    },
  },
})
export default class VirtualKeyboard extends Vue {
  clue!: Clue | null;
  xSelect!: boolean;

  emitCrosswordKeyEvent(key: string) {
    emitCrosswordKeyEvent(key);
  }

}
</script>

<style scoped>
#keyboard {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;
    padding-top: 10px;
    background: #e4eaef;
    z-index: 99;
    max-height: 300px;
}

.keyline {
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
}

#keyboard ul {
    padding: 0;
    margin: 0;
    padding-bottom: 10px;
}

#keyboard ul li {
    list-style: none;
    width: 8.5vw;
    height: 11vw;
    background: #fff;
    margin: 0 0.65%;
    font-size: clamp(1rem, 7vw, 32px);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 7px;
    cursor: pointer;
    max-height: 64px;
}

#keyboard ul li:hover {
    opacity: 0.8;
}

#keyboard ul li:active {
    background: var(--cnvs-themecolor) !important;
    color: #fff;
}

.on {
    display: block;
}
.special-key {
    width: 12vw !important;
    background-color: #c9d1d9 !important;
}
.selected-clue-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
    background: #e4eaef;
    font-size: 16px;
    height: 40px;
    position: relative;
}
.clue-text {
    padding-left: 10px;
}
.right-chevron {
    cursor: pointer;
    padding: 10px;
}
.right-chevron:active {
    background: var(--cnvs-themecolor) !important;
    color: #fff;
}
.clue-text {
    flex: 1;
}
</style>
